import {BlueshiftAPIConnectorError, restfulApiClient} from "./api.ts";
import type {Flavor, Instance, OSImage} from "./ModelTypes.ts";
import {et} from "../locales/i18n.tsx";


export class InstanceAPIConnectorError extends BlueshiftAPIConnectorError {
    public readonly localization;

    constructor(err: BlueshiftAPIConnectorError, localization: string) {
        super(err.cause, err.message);
        this.localization = localization;
    }
}

/**
 * 아래는 모델로 변경 가능
 * @namespace
 *
 */
export const instance_manager = {
    flavors: [] as Flavor[],
    osImages: [] as OSImage[],
    instances: [] as Instance[],


    /**
     * @param name instance name
     * @param {String} flavor_id flavor_id
     * @param {String} os_image_id os image id
     * @param {boolean} isSnapshot
     * @param {String} keypair keypair name
     * @param {String} cloud_init cloud_init name
     */
    async createInstance(
        name: string,
        flavor_id: string,
        os_image_id: string,
        isSnapshot: boolean,
        keypair: string,
        cloud_init: string,
    ) {
        try {
            const res = await restfulApiClient.post(`server/${name}`, 1, {
                "instance_name":  name,
                "flavor_id": flavor_id,
                "image_id": os_image_id,
                "is_snapshot": isSnapshot,
                "keypair_name": keypair,
                "cloud_init_name": cloud_init,
            });
            if(!res) return;

            return res.data;
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new InstanceAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }

        // callback(null);
        //
        // const socket = createWebsocket('instance/create');
        // socket.onopen = () => {
        //     const payload = {
        //         'X-Session-Id': persistentStorage["session_id"],
        //         'instance': {
        //             'name': name,
        //             'image': os_image_id,
        //             'is_snapshot': isSnapshot,
        //             'flavor': flavor_id,
        //             'keypair': keypair,
        //             'cloud_init': cloud_init
        //         }
        //     }
        //     socket.send(JSON.stringify(payload));
        // };
        //
        // socket.onmessage = e => {
        //     const data = JSON.parse(e.data);
        //     callback(data);
        // };
        //
        // socket.onerror = e => {
        //     console.log("onerror");
        //     console.log(e);
        // }
        //
        // socket.onclose = e => {
        //     console.log("closed");
        //     console.log(e);
        // }
    },

    async deleteInstance(server_id: number) {
        try {
            return await restfulApiClient.delete(`server/${server_id}`, 1);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new InstanceAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    //region Instance Action
    instanceAction: {
        async hardRestart(instance_id: number) {
            return await this._execute({instance: instance_id, action: "reboot/hard"});
        },

        async softRestart(instance_id: number) {
            return await this._execute({instance: instance_id, action: "reboot"});
        },

        async shutdown(instance_id: number) {
            return await this._execute({instance: instance_id, action: "stop"})
        },

        async boot(instance_id: number) {
            return await this._execute({instance: instance_id, action: "start"})
        },

        async pause(instance_id: number) {
            return await this._execute({instance: instance_id, action: "pause"})
        },

        async resume(instance_id: number) {
            return await this._execute({instance: instance_id, action: "resume"})
        },

        async _execute({instance, action}: {
            instance: number, action: string
        }) {
            try {
                return await restfulApiClient.post(`server/${instance}/${action}`, 1, null);
            } catch (err) {
                console.log(err)
                if (err instanceof BlueshiftAPIConnectorError) {
                    throw new InstanceAPIConnectorError(err, et(err.cause));
                }
                throw err;
            }
        },
    },
    //endregion

    /**
     * Flavor ID로 이름을 찾음
     * @param {string} id flavor id
     * @returns {string?} 이름를 찾은 경우 이름, 아니면 id를 그대로 리턴
     */
    getFlavorName: (id: string): string|undefined => {
        if (instance_manager.flavors.length === 0) return id;
        for (const elem of instance_manager.flavors) {
            const data: Flavor = elem;
            if (data.id === id) {
                return data.name;
            }
        }
    },

    getInstanceName: (id: number) => {
        if (instance_manager.instances.length === 0) return id;

        for (const elem of instance_manager.instances) {
            const data: Instance = elem;
            if (data.id === id) {
                return data.name;
            }
        }
    },

    prepare: async function () {
        try {
            const image = await restfulApiClient.get("server/images", 1);
            if (image) {
                this.osImages = image.data.data;
            }
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new InstanceAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }

        try {
            const flavor = await restfulApiClient.get("server/flavors", 1);
            if (flavor) {
                this.flavors = flavor.data.data;
            }

        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new InstanceAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async getInstanceList(instanceType?: string) {
        try {
            const url = instanceType
                ? `server?instance_type=${encodeURIComponent(instanceType)}`
                : "server";

            const instance = await restfulApiClient.get(url, 1);
            if (instance) {
                instance_manager.instances = instance.data.data;
            }
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new InstanceAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async getInstanceDetail(instanceId: string) {
        try {
            return await restfulApiClient.get(`server/${instanceId}`, 1);

        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new InstanceAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    }
}